/**
 * @generated SignedSource<<6238c59b75c7f7e374637ad65ce91807>>
 * @relayHash 9a9c9f71797c041d0234557239b4c6e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID df63ac7e0295bff036a9dcf0ca3e6bccd2bacc6c42e043cc7b0ee7d7b6ade4ad

import type { ConcreteRequest } from 'relay-runtime';
export type resolveAgentSessionsCloudIdQuery$variables = {
  rovoActivationId: string;
};
export type resolveAgentSessionsCloudIdQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly cloudId: string | null;
  } | null> | null;
};
export type resolveAgentSessionsCloudIdQuery = {
  response: resolveAgentSessionsCloudIdQuery$data;
  variables: resolveAgentSessionsCloudIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rovoActivationId"
  }
],
v1 = [
  {
    "args": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "activationIds.0",
            "variableName": "rovoActivationId"
          }
        ],
        "kind": "ListValue",
        "name": "activationIds"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "cloudId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "resolveAgentSessionsCloudIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "resolveAgentSessionsCloudIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "df63ac7e0295bff036a9dcf0ca3e6bccd2bacc6c42e043cc7b0ee7d7b6ade4ad",
    "metadata": {},
    "name": "resolveAgentSessionsCloudIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c31ba1b82eb0966659d0b2058ab65de0";

export default node;
